export const environment = {
    production: false,
    apiUrl: 'https://sensesiant.com/api',
    webSocketDomainUrl: 'https://sensesiant.com/ws-api',
    webSocketApiUrl: 'wss://sensesiant.com/ws',
    fileUrl: 'assets/resources/',
};
